import React from 'react'

function Footer() {
  return (
    <div className='bg-dark text-white text-center  py-3'>Copyright 2022 @Hariharan NKS</div>
  )
}

export default Footer